import IceBreaker from 'redhotpie-shared-lib/models/iceBreaker';
import * as types from '../constants/actionTypes';
import initialState from './initialState';
import { ActionType } from '../constants/actionTypes';

export default function iceBreakerReducer(state = initialState.iceBreakers, action: { type: ActionType; iceBreakers: IceBreaker[] }) {
  switch (action.type) {
    case types.LOAD_ICE_BREAKER_SUCCESS:
      return action.iceBreakers;

    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.iceBreakers;
      return state;
    }
    default:
      return state;
  }
}
